import { EnumFilter } from "@/components/data-table/components/EnumFilter";
import { BOOLEAN_VALUES, PATH_USER } from "@/constants";
import { DisplayEmailRecipient } from "@/types/emailRecipient";
import { Row } from "@tanstack/react-table";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { generatePath } from "react-router-dom";

export const useEmailRecipientsDirectoryColumnOverrides = () => {
  const { t } = useTranslation();

  return useMemo(
    () => ({
      recipient_full_name: {
        id: "recipient_full_name",
        meta: {
          externalPath: (row: DisplayEmailRecipient) =>
            generatePath(PATH_USER, { userId: row.recipient_id }),
        },
      },
      recipient_account_status: {
        id: "recipient_account_status",
        meta: {
          filter: {
            component: EnumFilter,
            props: {
              options: BOOLEAN_VALUES,
              translationKey: "activeValues",
            },
          },
        },
        cell: ({ row }: { row: Row<DisplayEmailRecipient> }) =>
          row.original.recipient_account_status
            ? t("users.status.active")
            : t("users.status.inactive"),
      },
    }),
    [t],
  );
};
